import React from 'react';
import {
  Box,
  Tabs,
  Tab,
  Card,
  alpha,
} from '@mui/material';

interface CommunityTabsProps {
  activeTab: number;
  setActiveTab: (value: number) => void;
  isDark: boolean;
  goldColor: string;
  deepGreen: string;
  glassEffect: any;
  lokiGradient: string;
  isMobile: boolean;
}

const CommunityTabs: React.FC<CommunityTabsProps> = ({
  activeTab,
  setActiveTab,
  isDark,
  goldColor,
  deepGreen,
  glassEffect,
  lokiGradient,
  isMobile,
}) => {
  const tabs = [
    { id: 'posts', label: 'Posts' },
    { id: 'about', label: 'About' },
    { id: 'members', label: 'Members' },
    { id: 'rules', label: 'Rules' }
  ];

  return (
    <Card sx={{ 
      p: 0, 
      mb: { xs: 2, md: 4 }, 
      borderRadius: '20px', 
      ...glassEffect,
      minHeight: { xs: 'auto', md: '72px' },
      display: 'flex',
      alignItems: 'center'
    }}>
      <Box sx={{ width: '100%', px: { xs: 1, md: 3 }, py: { xs: 1, md: 2 }, overflowX: 'auto' }}>
        <Tabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
          variant={isMobile ? "scrollable" : "standard"}
          scrollButtons="auto"
          sx={{
            minHeight: { xs: '40px', md: '48px' },
            '& .MuiTabs-flexContainer': {
              gap: 1,
            },
            '& .MuiTab-root': { 
              color: isDark ? 'rgba(255, 255, 255, 0.7)' : 'rgba(5, 24, 20, 0.7)', 
              fontWeight: 600, 
              textTransform: 'none', 
              fontSize: { xs: '0.8rem', md: '1rem' },
              borderRadius: '12px',
              padding: { xs: '6px 12px', md: '8px 24px' },
              minHeight: { xs: '36px', md: '48px' },
              minWidth: { xs: '120px', md: '180px' },
              transition: 'all 0.2s',
              '&.Mui-selected': { 
                color: isDark ? deepGreen : goldColor,
                background: isDark 
                  ? `linear-gradient(135deg, ${goldColor} 0%, ${alpha(goldColor, 0.8)} 100%)`
                  : lokiGradient,
                boxShadow: `0 4px 20px ${alpha(isDark ? goldColor : deepGreen, 0.2)}`,
              }
            }, 
            '& .MuiTabs-indicator': { 
              display: 'none'
            } 
          }}
        >
          {tabs.map((tab, index) => (
            <Tab key={tab.id} label={tab.label} />
          ))}
        </Tabs>
      </Box>
    </Card>
  );
};

export default CommunityTabs;